
const isSportsSection = (
  pathname: string = window.location.pathname,
  search: string = window.location.search,
): boolean =>
  pathname.startsWith('/sports') ||
  new URLSearchParams(search).get('section') === 'sports'

export default isSportsSection
